import {
    useSaveThemeSettings,
    useThemeSettings,
} from "Api/Admin/Theme";
import React, { useEffect, useRef, useState } from "react";
import { Loader } from "react-bootstrap-typeahead";
import {
    defaultThemeSettings,
    mapBackendThemeSettings,
    applyThemeToRoot,
    setCachedThemeSettings,
} from "../../../helperFunctions/UiTheme";


const LEGACY_BUTTON_SIZES = {
    sm: "33px",
    md: "35px",
    lg: "37px",
};

const SECONDARY_FONT_SIZE_OPTIONS = Array.from(
    { length: 7 },
    (_, index) => {
        const value = 8 + index * 2;
        return {
            value: `${value}px`,
            label: `${value}px`,
        };
    }
);

const FONT_FAMILY_OPTIONS = [
    { value: "system-ui", label: "System UI" },
    { value: "Arial", label: "Arial" },
    { value: "Roboto", label: "Roboto" },
    { value: "Helvetica Neue", label: "Helvetica Neue" },
];

const BUTTON_HEIGHT_OPTIONS = Array.from(
    { length: 14 },
    (_, index) => {
        const value = 18 + index * 2;
        return {
            value: `${value}px`,
            label: `${value}px`,
        };
    }
);

/* New option lists for the 6 added variables */

const INPUT_FIELD_HEIGHT_OPTIONS = Array.from(
    { length: 14 },
    (_, index) => {
        const value = 18 + index * 2;
        return {
            value: `${value}px`,
            label: `${value}px`,
        };
    }
);

const HEADER_TEXT_SIZE_OPTIONS = Array.from(
    { length: 7 },
    (_, index) => {
        const value = 8 + index * 2;
        return {
            value: `${value / 16}rem`,
            label: `${value}px`,
        };
    }
);

const SELECT_DROP_HEIGHT_OPTIONS =Array.from(
    { length: 14 },
    (_, index) => {
        const value = 18 + index * 2;
        return {
            value: `${value}px`,
            label: `${value}px`,
        };
    }
);

const SIDEBAR_SIZE_LABEL_OPTIONS = Array.from(
    { length: 7 },
    (_, index) => {
        const value = 8 + index * 2;
        return {
            value: `${value}px`,
            label: `${value}px`,
        };
    }
);


const DIVIDER_WIDTH_OPTIONS = Array.from(
    { length: 8 },
    (_, index) => {
        const value = index;
        return {
            value: `${value}px`,
            label: `${value}px`,
        };
    }
);

const HEADER_HEIGHT_OPTIONS = [40, 45, 51, 56, 60].map(
    (value) => ({
        value: `${value}px`,
        label: `${value}px`,
    })
);

const TABLE_ROW_HEIGHT_OPTIONS = Array.from(
    { length: 11 },
    (_, index) => {
        const value = 20 + index * 2;
        return {
            value: `${value}px`,
            label: `${value}px`,
        };
    }
);

const CARD_FONT_SIZE_OPTIONS = Array.from(
    { length: 11 },
    (_, index) => {
        const value = index + 9;
        return {
            value: `${(value / 16).toFixed(2).replace(/0+$/, "").replace(/\.$/, "")}rem`,
            label: `${value}px`,
        };
    }
);

const TABLE_FONT_SIZE_OPTIONS = Array.from(
    { length: 11 },
    (_, index) => {
        const value = index + 9;
        return {
            value: `${(value / 16).toFixed(2).replace(/0+$/, "").replace(/\.$/, "")}rem`,
            label: `${value}px`,
        };
    }
);

const FOOTER_HEIGHT_OPTIONS = [
    ...Array.from({ length: 16 }, (_, index) => {
        const value = 42 + index * 2;
        return {
            value: `${value}px`,
            label: `${value}px`,
        };
    }),
];

const MENU_HEIGHT_OPTIONS = Array.from(
    { length: 13 },
    (_, index) => {
        const value = 20 + index * 2;
        return {
            value: `${value}px`,
            label: `${value}px`,
        };
    }
);

const SIDEBAR_WIDTH_OPTIONS = Array.from(
    { length: 101 },
    (_, index) => {
        const value = 150 + index * 2;
        return {
            value: `${value}px`,
            label: `${value}px`,
        };
    }
);

const SIDEBAR_COLLAPSED_WIDTH_OPTIONS = Array.from(
    { length: 25 },
    (_, index) => {
        const value = 102 + index * 2;
        return {
            value: `${value}px`,
            label: `${value}px`,
        };
    }
);

const SIDEBAR_LEFT_PADDING_OPTIONS = Array.from(
    { length: 15 },
    (_, index) => {
        const value = 2 + index * 2;
        return {
            value: `${value}px`,
            label: `${value}px`,
        };
    }
);

const CHECKBOX_HEIGHT_OPTIONS =Array.from(
    { length: 10 },
    (_, index) => {
        const value = 12 + index * 2;
        return {
            value: `${value}px`,
            label: `${value}px`,
        };
    }
);

const CHECKBOX_WIDTH_OPTIONS = Array.from(
    { length: 10 },
    (_, index) => {
        const value = 12 + index * 2;
        return {
            value: `${value}px`,
            label: `${value}px`,
        };
    }
);

const PAGINATION_FONT_SIZE_OPTIONS = Array.from(
    { length: 11 },
    (_, index) => {
        const value = index + 9;
        return {
            value: `${(value / 16).toFixed(2).replace(/0+$/, "").replace(/\.$/, "")}rem`,
            label: `${value}px`,
        };
    }
);

const SIDEBAR_COLLAPSED_PADDING_LEFT_OPTIONS = Array.from(
    { length: 15 },
    (_, index) => {
        const value = 0 + index * 2;
        return {
            value: `${value}px`,
            label: `${value}px`,
        };
    }
);

const SIDEBAR_COLLAPSED_LABEL_SIZE_OPTIONS = Array.from(
    { length: 11 },
    (_, index) => {
        const value = index + 9;
        return {
            value: `${(value / 16).toFixed(2).replace(/0+$/, "").replace(/\.$/, "")}rem`,
            label: `${value}px`,
        };
    }
);

const  COLLAPSED_MENU_HEIGHT_OPTIONS=Array.from(
    { length: 13 },
    (_, index) => {
        const value = 20 + index * 2;
        return {
            value: `${value}px`,
            label: `${value}px`,
        };
    }

);

const COLLAPSED_MENU_SIZE_OPTIONS=Array.from(
    { length: 7 },
    (_, index) => {
        const value = 8 + index * 2;
        return {
            value: `${value}px`,
            label: `${value}px`,
        };
    }

);
const WIDGET_TOP_PADDING_OPTIONS = Array.from(
    { length: 8 },
    (_, index) => {
        const value = 1 + index * 0.5;
        return {
            value: `${value}rem`,
            label: `${value}rem`,
        };
    }
);
const WIDGET_BOTTOM_PADDING_OPTIONS = Array.from(
    { length: 8 },
    (_, index) => {
        const value = 1 + index * 0.5;
        return {
            value: `${value}rem`,
            label: `${value}rem`,
        };
    }
);

const CARD_ROW_GAP_OPTIONS = [
    { value: "2px", label: "2px" },
    { value: "3px", label: "3px" },
    { value: "4px", label: "4px" },
    { value: "5px", label: "5px" },
    { value: "6px", label: "6px" },
    { value: "8px", label: "8px" },
    { value: "10px", label: "10px" },
    { value: "12px", label: "12px" },
    { value: "14px", label: "14px" },
    { value: "16px", label: "16px" },
    { value: "18px", label: "18px" },
    { value: "20px", label: "20px" },
    { value: "22px", label: "22px" },
    { value: "24px", label: "24px" },
    { value: "28px", label: "28px" },
    { value: "32px", label: "32px" },
];

const GRID_ROW_GAP_OPTIONS = CARD_ROW_GAP_OPTIONS.map((option) => ({
    ...option,
}));
const SECTIONS = [
    {
        title: "Global settings ",
        description: "Manage your application's global settings",
        settings: [
            {
                name: "primaryColor",
                type: "color",
                label: "Widget Title Text Color",
                description: "Widget title text color",
            },
            {
                name: "textColor",
                type: "color",
                label: "Widget and Tables Text Color",
                description: "Color of the text inside tables and Widget",
            },
            {
                name: "tableHeaderColor",
                type: "color",
                label: "Table Heading Text Color ",
                description: "Table heading text color ",

            },
            {
                name: "tableHoverTextColor",
                type: "color",
                label: "Table Hover Text Color",
                description: "table hover color ",

            },
            {
                name: "headerHeadColor",
                type: "color",
                label: "Table Heading Background Color",
                description: "Table Heading Background Color",

            },
            {
                name: "headerRowColor",
                type: "color",
                label: "Table Row Background Color",
                description: "Table Row Background Color",

            },
            {
                name: "tableRowBgColor",
                type: "color",
                label: "Table Hover Background Color",
                description: "Table Row Background Color",

            },

            {
                name: "TableFontSize",
                type: "select",
                label: "Table Text Size",
                description: "Table Text size",
                options: TABLE_FONT_SIZE_OPTIONS,
            },

            {
                name: "cardFontSize",
                type: "select",
                label: "Widget Text size",
                description: "Widget Text Size",
                options: CARD_FONT_SIZE_OPTIONS,
            },

            {
                name: "tableHeight",
                type: "select",
                label: "Table Row Height",
                description: "Table row Height",
                options: TABLE_ROW_HEIGHT_OPTIONS,
            },

             {
                name: "cardPaddingTop",
                type: "select",
                label: "Widget Top Padding",
                description: "Top Padding of Widget",
                options: WIDGET_TOP_PADDING_OPTIONS,
            },
             {
                name: "cardPaddingBottom",
                type: "select",
                label: "Widget Bottom Padding",
                description: "Bottom padding of Widget",
                options: WIDGET_BOTTOM_PADDING_OPTIONS,
            },

            {
                name: "cardRowGap",
                type: "select",
                label: "Widget Row Gap",
                description: "Vertical row spacing for widgets and forms",
                options: CARD_ROW_GAP_OPTIONS,
            },

            {
                name: "gridRowGap",
                type: "select",
                label: "Grid Gap",
                description: "Row gap for grid layouts (e.g. Vervangingsverzoek)",
                options: GRID_ROW_GAP_OPTIONS,
            },


        ],
    },


    {
        title: "Header Widget",
        description: "Customize Header appearance",
        settings: [
            {
                name: "headerColor",
                type: "color",
                label: "Header Background Color",
                description: "Background color of the top header bar",
            },
            {
                name: "UserNameColor",
                type: "color",
                label: "Profilename",
                description: "Profilename Text Color",
            },
            {
                name: "profileMenuColor",
                type: "color",
                label: "Profilename Menu Dropdown Text Color",
                description: "Profilename Menu Dropdown Text Color",
            },
            {
                name: "profileMenuDropdown",
                type: "color",
                label: "Profilename Menu Dropdown Background Color",
                description: "Profilename Menu Dropdown Background Color",
            },

            {
                name: "BreadcrumbColor",
                type: "color",
                label: "Breadcrumb Text Color",
                description: "color of the breadcrumb in header bar",
            },
            {
                name: "BreadCrumbSlashColor",
                type: "color",
                label: "Breadcrumb Separator Color",
                description: "color of the breadcrumb separator in header bar",
            },

            {
                name: "DividerColor",
                type: "color",
                label: "Profile Divider Color",
                description: "Divider color in header bar",
            },

            {
                name: "DividerWidth",
                type: "select",
                label: "Divider Width",
                description: "width of the divider",
                options: DIVIDER_WIDTH_OPTIONS,
            },
            {
                name: "headerTextSize",
                type: "select",
                label: "BreadCrumb Text Size",
                description: "Font size of text BreadCrumb in header bar",
                options: HEADER_TEXT_SIZE_OPTIONS,
            },
            {
                name: "headerHeight",
                type: "select",
                label: "Header Height",
                description: "Height of the top header bar",
                options: HEADER_HEIGHT_OPTIONS,
            },

        ],
    },
    {
        title: "Global Components",
        description: "Customize components appearance",
        settings: [
            {
                name: "buttonsColor",
                type: "color",
                label: "Button Color",
                description: "color of buttons ",

            },
            {
                name: "selectColor",
                type: "color",
                label: "Dropdown Color",
                description: "color of dropdowns ",

            },
            {
                name: "inputFieldColor",
                type: "color",
                label: "Input Field Color",
                description: "Border Color input fields",

            },
            {
                name: "themeColor",
                type: "color",
                label: " General Background Color",
                description: "General background Color across the whole application",

            },
            {
                name: "iconColor",
                type: "color",
                label: "Icons Color",
                description: "Icons color",

            },
            {
                name: "fontFamily",
                type: "select",
                label: "Application Font",
                description: "Font used across the whole application",
                options: FONT_FAMILY_OPTIONS,
            },
            {
                name: "buttonSize",
                type: "select",
                label: "Button Height",
                description: "Height of buttons ",
                options: BUTTON_HEIGHT_OPTIONS,
            },
            {
                name: "inputFieldHeight",
                type: "select",
                label: "Input Field Height",
                description: "Height of text input fields",
                options: INPUT_FIELD_HEIGHT_OPTIONS,
            },
            {
                name: "selectDropHeight",
                type: "select",
                label: "Dropdown Height",
                description: "Height of dropdown/select fields",
                options: SELECT_DROP_HEIGHT_OPTIONS,
            },
            {
                name: "checkboxWidth",
                type: "select",
                label: "Checkbox and Radio Button Width",
                description: "Width of the checkbox",
                options: CHECKBOX_WIDTH_OPTIONS,
            },
            {
                name: "checkboxHeight",
                type: "select",
                label: "Checkbox and Radio Button Height",
                description: "Height of the checkbox",
                options: CHECKBOX_HEIGHT_OPTIONS,
            },
             {
                name: "paginationSize",
                type: "select",
                label: "Pagination Font Size",
                description: "Font size of pagination controls",
                options: PAGINATION_FONT_SIZE_OPTIONS,
            },


        ],
    },
    {
        title: "Sidebar",
        description: "Customize sidebar colors",
        settings: [

            {
                name: "sidebarBackGroundColor",
                type: "color",
                label: "Sidebar Background Color",
                description: "Sidebar Background Color",
            },
            {
                name: "sidebarColor",
                type: "color",
                label: "Sidebar Selected Background Color",
                description: "Sidebar selected Background Color",
            },
            {
                name: "sidebarSelectedItemColor",
                type: "color",
                label: "Sidebar Selected Menu Text Color",
                description: "selected menu text color",
            },
            {
                name: "greyColor",
                type: "color",
                label: "Sidebar Menu Text Color",
                description: "Sidebar Menu text color",
            },
            {
                name: "sidebarHoverColor",
                type: "color",
                label: "Sidebar Menu Hover Color",
                description: "Sidebar Menu Hover Color",
            },
            {
                name: "svgSecondaryColor",
                type: "color",
                label: "Sidebar Icons Color",
                description: "Color of icons in the sidebar",
            },
            {
                name: "SecondaryLabelColor",
                type: "color",
                label: "Sidebar Heading",
                description: "Heading in the sidebar",
            },
            {
                name: "sidebarSizeLabel",
                type: "select",
                label: "Sidebar Heading Size",
                description: "Font size of sidebar item labels",
                options: SIDEBAR_SIZE_LABEL_OPTIONS,
            },
            {
                name: "secondaryFontSize",
                type: "select",
                label: "Sidebar Menu Text Size",
                description: "Size of sidebar menu text",
                options: SECONDARY_FONT_SIZE_OPTIONS,
            },
            {
                name: "sidebarMenuHeight",
                type: "select",
                label: "Sidebar Menu Height",
                description: "Menu Height of sidebar menu",
                options: MENU_HEIGHT_OPTIONS,
            },
            {
                name: "sidebarPaddingLeft",
                type: "select",
                label: "Sidebar Left Padding",
                description: "Left padding of sidebar menu",
                options: SIDEBAR_LEFT_PADDING_OPTIONS,
            },
            {
                name: "sidebarWidth",
                type: "select",
                label: "Sidebar Width",
                description: "Sidebar width",
                options: SIDEBAR_WIDTH_OPTIONS,
            },
            {
                name: "sidebarCollapsedHeight",
                type: "select",
                label: "Sidebar Collapsed Menu Height",
                description: "Menu Height of collapsed sidebar",
                options: COLLAPSED_MENU_HEIGHT_OPTIONS,
            },
            {
                name: "sidebarCollapsedTextSize",
                type: "select",
                label: "Sidebar Collapsed Menu Text size",
                description: "Menu Size of collapsed sidebar",
                options: COLLAPSED_MENU_SIZE_OPTIONS,
            },
            {
                name: "sidebarCollapsedWidth",
                type: "select",
                label: "Sidebar Collapsed Width",
                description: "Sidebar collapsed width",
                options: SIDEBAR_COLLAPSED_WIDTH_OPTIONS,
            },
             {
                name: "sidebarCollapsePaddingLeft",
                type: "select",
                label: "Sidebar Collapsed Left Padding",
                description: "Left padding of sidebar when collapsed",
                options: SIDEBAR_COLLAPSED_PADDING_LEFT_OPTIONS,
            },
            {
                name: "sidebarCollapsedLabelSize",
                type: "select",
                label: "Sidebar Collapsed Label Size",
                description: "Font size of sidebar labels when collapsed",
                options: SIDEBAR_COLLAPSED_LABEL_SIZE_OPTIONS,
            }

        ],
    },

    {
        title: "Footer",
        description: "Configure application Global font",
        settings: [

            {
                name: "footerHeight",
                type: "select",
                label: "Footer Height",
                description: "Footer Height",
                options: FOOTER_HEIGHT_OPTIONS,
            },

            {
                name: "cardFooterBackground",
                type: "color",
                label: "Footer Background",
                description: "Footer Background",

            },

        ],
    },
];

const normalizeSettings = (settings) => ({
    ...settings,
    buttonSize: LEGACY_BUTTON_SIZES[settings.buttonSize] || settings.buttonSize,
});

const isUsingDefault = (settings) => {
    if (!settings) {
        return false;
    }

    return Object.keys(defaultThemeSettings).every(
        (key) => settings[key] === defaultThemeSettings[key]
    );
};

const formatDisplayValue = (value) => {
    if (typeof value === "string" && value.endsWith("rem")) {
        return `${Math.round(parseFloat(value) * 16)}px`;
    }

    return value;
};

const ColorInput = ({ value, onCommit }) => {
    const inputRef = useRef(null);
    const onCommitRef = useRef(onCommit);

    onCommitRef.current = onCommit;

    useEffect(() => {
        const input = inputRef.current;

        const handleCommit = (e) => onCommitRef.current(e.target.value);

        input.addEventListener("change", handleCommit);

        return () => input.removeEventListener("change", handleCommit);
    }, []);

    useEffect(() => {
        if (inputRef.current && inputRef.current.value !== value) {
            inputRef.current.value = value;
        }
    }, [value]);

    return <input ref={inputRef} type="color" defaultValue={value} />;
};

const SettingValue = ({ value, isColor = false, isNew = false }) => (
    <div
        className={`theme-setting-value ${isNew ? "theme-setting-value--new" : ""}`}
    >
        {isColor && (
            <span className="theme-color-preview" data-color={value} />
        )}

        <span className="theme-setting-value-text">
            {isColor ? value : formatDisplayValue(value)}
        </span>
    </div>
);

const SettingChange = ({ oldValue, isColor }) => (
    <div className="theme-setting-change">
        <SettingValue value={oldValue} isColor={isColor} />
        <span className="theme-setting-arrow">→</span>
    </div>
);

const SettingRow = ({ setting, value, oldValue, onChange }) => {
    const { name, type, label, description, options } = setting;
    const isColor = type === "color";

    return (
        <div className="theme-settings__row">
            <div className="theme-setting-info">
                <p>{label}</p>
                <small>{description}</small>
            </div>

            <div className="theme-setting-control">
                <SettingChange oldValue={oldValue} isColor={isColor} />

                {isColor ? (
                    <ColorInput
                        value={value}
                        onCommit={(newValue) => onChange(name, newValue)}
                    />
                ) : (
                    <select
                        value={value}
                        onChange={(e) => onChange(name, e.target.value)}
                    >
                        {options.map((option) => (
                            <option key={option.value} value={option.value}>
                                {option.label}
                            </option>
                        ))}
                    </select>
                )}
            </div>
        </div>
    );
};

const Theme = () => {
    const {
        data: themeSettingsData,
        isLoading: isThemeLoading,
    } = useThemeSettings();

    const {
        trigger: saveThemeSetting,
        isMutating,
    } = useSaveThemeSettings();

    const [themeSettings, setThemeSettings] = useState(null);
    const [previousSettings, setPreviousSettings] = useState(null);

    useEffect(() => {
        applyThemeToRoot(themeSettings);
    }, [themeSettings]);

    useEffect(() => {
        if (isThemeLoading) {
            return;
        }

        const apiData =
            themeSettingsData?.data ||
            themeSettingsData ||
            [];

        const settings = normalizeSettings(mapBackendThemeSettings(apiData));

        setThemeSettings(settings);
        setPreviousSettings(settings);
    }, [themeSettingsData, isThemeLoading]);

    const saveSetting = (key, oldValue, newValue) =>
        saveThemeSetting({
            data: {
                vThemeName: key,
                vPrimaryValue: oldValue,
                vSecondaryValue: newValue,
            },
        });

    const updateSetting = (key, value) => {
        const oldValue = themeSettings[key];

        if (oldValue === value) {
            return;
        }

        const updatedSettings = {
            ...themeSettings,
            [key]: value,
        };

        setPreviousSettings((prev) => ({
            ...prev,
            [key]: oldValue,
        }));

        setThemeSettings(updatedSettings);

        saveSetting(key, oldValue, value)
            .then(() => {
                setCachedThemeSettings(updatedSettings);
            })
            .catch((error) => {
                console.error("Failed to save theme setting:", error);

                setThemeSettings((prev) => ({
                    ...prev,
                    [key]: oldValue,
                }));
            });
    };

    const resetToDefault = () => {
        if (isUsingDefault(themeSettings)) {
            return;
        }

        const oldSettings = themeSettings;

        const changedKeys = Object.keys(defaultThemeSettings).filter(
            (key) => oldSettings[key] !== defaultThemeSettings[key]
        );

        setPreviousSettings(oldSettings);
        setThemeSettings(defaultThemeSettings);

        Promise.all(
            changedKeys.map((key) =>
                saveSetting(key, oldSettings[key], defaultThemeSettings[key])
            )
        )
            .then(() => {
                setCachedThemeSettings(defaultThemeSettings);
            })
            .catch((error) => {
                console.error("Failed to reset theme:", error);

                setThemeSettings(oldSettings);
                setPreviousSettings(oldSettings);
            });
    };

    if (isThemeLoading || !themeSettings || !previousSettings) {
        return <div><Loader /></div>;
    }

    const isDefault = isUsingDefault(themeSettings);

    return (
        <div className="theme-settings">

            <div className="theme-settings__header d-flex justify-content-between align-items-center mb-4">
                <div>
                    <h4>Theme Settings</h4>
                    <p className="mb-0">Customize the appearance of your application</p>
                </div>

                <div className="d-flex align-items-center gap-3">
                    {isMutating && (
                        <span className="theme-settings__saving">
                            Saving...
                        </span>
                    )}

                    <button
                        type="button"
                        className="btn btn-primary "
                        onClick={resetToDefault}
                        disabled={isMutating || isDefault}
                    >
                        {isDefault
                            ? "Default Theme Applied"
                            : "Apply Default Theme"}
                    </button>
                </div>
            </div>

            {SECTIONS.map((section) => (
                <div className="theme-settings__section" key={section.title}>
                    <div className="theme-settings__section-header">
                        <div>
                            <h6>{section.title}</h6>
                            <small>{section.description}</small>
                        </div>
                    </div>

                    {section.settings.map((setting) => (
                        <SettingRow
                            key={setting.name}
                            setting={setting}
                            value={themeSettings[setting.name]}
                            oldValue={previousSettings[setting.name]}
                            onChange={updateSetting}
                        />
                    ))}
                </div>
            ))}
        </div>
    );
};

export default Theme;